import PropTypes from 'prop-types';
import styles from './ProductOrder.module.scss';
import { getTotal } from 'reactjs/components/utility';
import Button from '@polydice/ui/dist/Button';
import classNames from 'classnames';

const ProductOrder = ({
  product,
  coupon,
  user,
  orderProducts,
  onClick,
  darkMode
}) => {
  const discountPolicy = coupon && coupon.policy;
  const { fare, fareThreshold } = product;
  const vip = user && user.vip;
  const { total, productsTotal, fareTotal, discountTotal } = getTotal(
    vip,
    coupon,
    fare,
    fareThreshold,
    orderProducts
  );

  const showShippingCoupon =
    coupon && discountPolicy === 'shipping' && fareTotal !== 0;
  const showOtherCoupon =
    coupon && discountPolicy !== 'shipping' && !(coupon.vip_only && !vip);

  return (
    <section
      className={classNames(styles.productOrder, {
        'dark-mode gray2-bgc no-border': darkMode
      })}
    >
      <div className={styles.productOrderMobile}>
        <div className={styles.productOrderMobileContainer}>
          <div className={styles.productOrderMobileContainerDetail}>
            <p
              className={classNames(
                styles.productOrderMobileContainerDetailFirst,
                {
                  'dark-mode gray2-bgc': darkMode
                }
              )}
            >
              NT$ {productsTotal}
            </p>
            <p className={styles.productOrderMobileContainerDetailLast}>
              <span
                className={classNames(
                  styles.productOrderMobileContainerDetailLastFare,
                  {
                    'dark-mode gray2-bgc': darkMode
                  }
                )}
              >
                {' '}
                {`(運費+${fareTotal})`}{' '}
              </span>
              {showShippingCoupon && (
                <span
                  className={classNames(
                    styles.productOrderMobileContainerDetailLastCoupon,
                    {
                      'dark-mode gray2-bgc': darkMode
                    }
                  )}
                >{` (運費-${discountTotal}) `}</span>
              )}
              {showOtherCoupon && (
                <span
                  className={classNames(
                    styles.productOrderMobileContainerDetailLastCoupon,
                    {
                      'dark-mode gray2-bgc': darkMode
                    }
                  )}
                >{` (折扣-${discountTotal}) `}</span>
              )}
            </p>
          </div>
          <Button
            className={classNames(styles.productOrderMobileContainerButton, {
              'dark-mode blue-button': darkMode
            })}
            styleType="contained"
            color="primary"
            onClick={onClick}
          >
            前往結帳
          </Button>
        </div>
      </div>
      <div className={styles.productOrderDesktop}>
        <p
          className={classNames(styles.productOrderDesktopTitle, {
            'dark-mode gray2-bgc': darkMode
          })}
        >
          已選購商品({Object.keys(orderProducts).length})
        </p>
        <div
          className={classNames(styles.productOrderDesktopDetail, {
            'dark-mode gray2-bgc': darkMode
          })}
        >
          <span
            className={classNames(styles.productOrderDesktopDetailFirst, {
              'dark-mode gray2-bgc': darkMode
            })}
          >
            商品
          </span>
          <span
            className={classNames(styles.productOrderDesktopDetailLast, {
              'dark-mode gray2-bgc': darkMode
            })}
          >
            {productsTotal}
          </span>
        </div>
        <div className={styles.productOrderDesktopDetail}>
          <span
            className={classNames(styles.productOrderDesktopDetailFirst, {
              'dark-mode gray2-bgc': darkMode
            })}
          >
            運費
          </span>
          <span
            className={classNames(styles.productOrderDesktopDetailLast, {
              'dark-mode gray2-bgc': darkMode
            })}
          >
            {fareTotal}
          </span>
        </div>
        {showShippingCoupon && (
          <div className={styles.productOrderDesktopCoupon}>
            <span
              className={classNames(styles.productOrderDesktopCouponFirst, {
                'dark-mode gray2-bgc': darkMode
              })}
            >
              運費折扣
            </span>
            <span
              className={classNames(styles.productOrderDesktopCouponLast, {
                'dark-mode gray2-bgc': darkMode
              })}
            >
              -{discountTotal}
            </span>
          </div>
        )}
        {showOtherCoupon && (
          <div className={styles.productOrderDesktopCoupon}>
            <span
              className={classNames(styles.productOrderDesktopCouponFirst, {
                'dark-mode gray2-bgc': darkMode
              })}
            >
              優惠券折扣
            </span>
            <span
              className={classNames(styles.productOrderDesktopCouponLast, {
                'dark-mode gray2-bgc': darkMode
              })}
            >
              -{discountTotal}
            </span>
          </div>
        )}
        <div className={styles.productOrderDesktopTotal}>
          <span
            className={classNames(styles.productOrderDesktopTotalFirst, {
              'dark-mode gray2-bgc': darkMode
            })}
          >
            小計
          </span>
          <span
            className={classNames(styles.productOrderDesktopTotalLast, {
              'dark-mode gray2-bgc': darkMode
            })}
          >
            NT$ {total}
          </span>
        </div>
        <Button
          styleType="contained"
          color="primary"
          fullWidth
          onClick={onClick}
          className={classNames({ 'dark-mode blue-button': darkMode })}
        >
          前往結帳
        </Button>
      </div>
    </section>
  );
};

ProductOrder.propTypes = {
  user: PropTypes.shape({
    vip: PropTypes.bool
  }),
  coupon: PropTypes.shape({
    policy: PropTypes.string,
    vip_only: PropTypes.bool
  }),
  product: PropTypes.shape({
    fare: PropTypes.number.isRequired,
    fareThreshold: PropTypes.number
  }).isRequired,
  orderProducts: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func.isRequired
};

ProductOrder.defaultProps = {
  user: null,
  coupon: null
};

export default ProductOrder;
